import alertConstants    from './alert.constants';
import alertInitialState from './alert.state';

function alertReducer(state = alertInitialState, action) {
  switch (action.type) {
    case alertConstants.SHOW_ALERT:
      state = {
        ...state,
        alerts: [
          { type:    action.messageType,
            message: action.message,
            key:     Date.now(),
          },
          ...state.alerts,
        ],
      };
      break;

    case alertConstants.HIDE_ALERT:
      state = {
        ...state,
        alerts: state.alerts.filter(alert => alert.key !== action.key),
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default alertReducer;